// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type IsInvoiceAlreadyPrintedQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['Int']['input'];
}>;


export type IsInvoiceAlreadyPrintedQueryResult = { __typename?: 'Query', isInvoiceAlreadyPrinted: boolean };

export const IsInvoiceAlreadyPrintedGql = gql`
    query IsInvoiceAlreadyPrinted($invoiceId: Int!) {
  isInvoiceAlreadyPrinted(invoiceId: $invoiceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsInvoiceAlreadyPrintedInjectable extends Apollo.Query<IsInvoiceAlreadyPrintedQueryResult, IsInvoiceAlreadyPrintedQueryVariables> {
    override document = IsInvoiceAlreadyPrintedGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */